import React from 'react';
export function ForWhomSection() {
  const yesList = ['Reconoces el ciclo Placer → Culpa → Vacío en tu experiencia', 'Ya probaste fuerza de voluntad y no fue suficiente', 'Quieres herramientas concretas, no más información sobre el problema', 'Prefieres trabajarlo en privado, sin terapia pública ni grupos', 'Estás dispuesto/a a 5-15 minutos diarios de práctica real'];
  const noList = ['Buscas una solución mágica sin ningún esfuerzo de tu parte', 'No estás dispuesto/a a ser honesto/a contigo mismo/a en el proceso', 'Necesitas atención clínica de urgencia — en ese caso busca ayuda médica primero'];
  return <section className="py-6 md:py-8 px-5 bg-[radial-gradient(ellipse_at_right,rgba(194,0,111,0.12)_0%,transparent_60%),var(--dark-bg)]" data-id="element-53" data-mp="o8w592jvc4eu">
      <div className="max-w-[900px] mx-auto" data-id="element-54" data-mp="38wiv8yv5o34e">
        <span className="inline-block font-heading font-bold text-[0.75rem] tracking-[3px] uppercase text-magenta-bright mb-2" data-id="element-55" data-mp="38vpmxtgjt5k5">
          ¿Es para ti?
        </span>

        <h2 className="text-[clamp(1.8rem,4vw,2.8rem)] font-heading font-black leading-[1.2] mb-3" data-id="element-56" data-mp="34t2bshp0hdnp">
          Esto es para ti si...
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mt-4" data-id="element-57" data-mp="2zv0pzp07b08j">
          {/* Yes Card */}
          <div className="rounded-2xl p-5 bg-[rgba(0,207,255,0.05)] border border-[rgba(0,207,255,0.3)]" data-id="element-58" data-mp="3dqme7tym1fzw">
            <h3 className="text-[1.2rem] font-heading font-bold text-blue-light mb-3" data-id="element-59" data-mp="38vyx4g5xrnvc">
              ✅ Sí es para ti
            </h3>
            <ul className="list-none space-y-0" data-id="element-60" data-mp="3islir7636iyf">
              {yesList.map((item, idx) => <li key={idx} className="flex items-start gap-3 py-2 border-b border-white/5 last:border-b-0 text-[0.95rem] text-white/80 leading-[1.5]" data-id="element-61" data-mp="ec8ehlcfk46" data-mpi={idx}>
                  <span className="text-[1.1rem] shrink-0 mt-[2px]" data-id="element-62" data-mp="ab7997539wlm">✓</span>
                  <span data-id="element-63" data-mp="5d5ngega3j6g">{item}</span>
                </li>)}
            </ul>
          </div>

          {/* No Card */}
          <div className="rounded-2xl p-5 bg-[rgba(194,0,111,0.05)] border border-[rgba(194,0,111,0.2)]" data-id="element-64" data-mp="2z5ww582ly4xf">
            <h3 className="text-[1.2rem] font-heading font-bold text-magenta-bright mb-3" data-id="element-65" data-mp="337a3xnp9gi6z">
              ❌ No es para ti si
            </h3>
            <ul className="list-none space-y-0" data-id="element-66" data-mp="383qpqb8zmkgw">
              {noList.map((item, idx) => <li key={idx} className="flex items-start gap-3 py-2 border-b border-white/5 last:border-b-0 text-[0.95rem] text-white/80 leading-[1.5]" data-id="element-67" data-mp="3cy4rqwi5npuj" data-mpi={idx}>
                  <span className="text-[1.1rem] shrink-0 mt-[2px] text-magenta-bright" data-id="element-68" data-mp="3qw1q9yg666bu">
                    ✗
                  </span>
                  <span data-id="element-69" data-mp="3vved4j71jdef">{item}</span>
                </li>)}
            </ul>
          </div>
        </div>
      </div>
    </section>;
}